import React from 'react'
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfo";

function PinLocations() {
    const [{ hole }] = useStateValue();
    return (
        <div>     

      <div className="loc__coords">
        <table>
        <tbody>
          <tr>
        <td className="loc__front">Front of Green</td>
        <td>{holes[hole].greenfront[0]}, {holes[hole].greenfront[1]} </td>
        </tr>
        </tbody>
        </table>
      </div>
      <div className="loc__coords">
        <table>
        <tbody>
        <tr>
        <th className="loc__front">Center of Green</th>
        <td>{holes[hole].greencenter[0]}, {holes[hole].greencenter[1]} </td>
        </tr>
        </tbody>
        </table>
      </div>
      <div className="loc__coords">
        <table>
        <tbody>
        <tr>
        <th className="loc__front">Back of Green</th>
        <td>{holes[hole].greenback[0]}, {holes[hole].greenback[1]} </td>
        </tr>
        </tbody>
        </table>
      </div>




        </div>
    )
}

export default PinLocations
